import { call } from 'redux-saga/effects';

let getListModule = null;

export function* getClientConsents(args){
  console.log({args})
  if (!getListModule) {
      getListModule = yield call(() => import("./get-client-consents"));
    }
    //llamada a modulo
    yield call(getListModule.getClientConsents, { ...args }); 
}

let saveClientConsentsModule = null;

export function* saveClientConsents(args){
  console.log({args})
  if (!saveClientConsentsModule) {
      saveClientConsentsModule = yield call(() => import("./save-client-consents"));
    }
    //llamada a modulo
    yield call(saveClientConsentsModule.saveClientConsents, { ...args }); 
}



